import React, { useState, useEffect, useCallback } from 'react';
import { Search as SearchAgent } from '@findify/agent';
import withField from '../withField';
import styles from './styles';
import { Select } from '../Select';

const renderProduct = ({ item, ...rest }) => (
  <button className={styles.product} {...rest}>
    <img
      src={item.thumbnail_url || item.image_url}
      className={styles.productImage}
    />
    <div className={styles.productContent}>{item.title.substring(0, 100)}</div>
  </button>
);

export const Autocomplete = ({
  name,
  label,
  apiKey,
  placeholder = 'Search...',
  normalize,
  fieldKey = 'id',
  labelKey,
  ...rest
}) => {
  const [agent, setAgent] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const _agent: any = new SearchAgent({
      key: apiKey,
      immutable: true,
      user: { uid: '1', sid: '1' },
      log: false,
    });
    setAgent(_agent);
    _agent.on('change:items', (items) => setOptions(items.toJS()));
    return () => _agent.off();
  }, []);

  const fetch = useCallback(
    (query) =>
      new Promise((resolve) => {
        const callback = (items) => {
          agent.off(callback);
          resolve(
            items
              .toJS()
              .reduce(
                (acc, o) => ({
                  ...acc,
                  [o[fieldKey]]: o[labelKey || fieldKey],
                }),
                {}
              )
          );
        };
        agent.set('q', query).on('change:items', callback);
      }),
    [agent]
  );

  if (!agent) return null;
  return (
    <Select
      {...rest}
      searchable
      ignoreSearch
      debounce
      placeholder={placeholder}
      label={label}
      name={name}
      fetch={fetch}
      itemRenderer={(props) =>
        renderProduct({
          ...props,
          item: options.find((o) => o[labelKey || fieldKey] === props.text),
        })
      }
    />
  );
};

Autocomplete.displayName = 'Autocomplete';

export default withField(Autocomplete);
